import { cn } from "@/lib/utils";

export const DockedContainer = ({
  children,
  className,
  isInDialog = false,
}: {
  children: React.ReactNode;
  className?: string;
  isInDialog?: boolean;
}) => {
  return (
    <div
      className={
        isInDialog
          ? cn("sticky bottom-0 left-0 right-0 bg-black z-50", className)
          : cn(
              "fixed bottom-0 left-0 right-0 bg-black/95 backdrop-blur-sm z-50 border-t border-gray-800",
              "fixed bottom-0 left-0 right-0 bg-black/95 backdrop-blur-sm z-50 border-t border-gray-800",
              className
            )
      }
    >
      <div className="p-4 flex justify-center items-center">{children}</div>
    </div>
  );
};
